"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");exports.__esModule=true;exports.default=_default;var _dragTracker=_interopRequireDefault(require("../chart/_internal/drag-tracker"));var _lib=require("@fusioncharts/core/src/lib");function _default(chart){(0,_lib.componentFactory)(chart,_dragTracker.default,"dragTracker");chart.getChildren("dragTracker")[0].addEvents()}


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/powercharts/src/factories/drag-tracker.js
// module id = oFnz
// module chunks = 5